import React from 'react';
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';
import MultiSelectInput from 'screens/components/basic/MultiSelectInput';
import BranchMultiSelectAutoCompleteInput from 'screens/components/basic/BranchMultiSelectAutoCompleteInput';

const componentName = "BudtenderAverageSales";
const Header = (props) => {
    const { defaultBranch, branchOptions } = props;
    return (
        <CardSimple className="pa-1">
            <div className="row row_margin_none bud-tender-avg-sales-header">
                <div className="col-xs-6 col-sm-6 col-md-3 col-lg-2 col-xl-2 m-0">
                    <DatePickerInput
                        name={componentName + LOOKUP.report.common.beginDate.name}
                        floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                        hintText={LOOKUP.report.common.beginDate.label + "*"}
                        fullWidth={true}
                    />
                </div> {/* .col */}
                <div className="col-xs-6 col-sm-6 col-md-3 col-lg-2 col-xl-2 m-0">
                    <DatePickerInput
                        name={componentName + LOOKUP.report.common.endDate.name}
                        floatingLabelText={LOOKUP.report.common.endDate.label}
                        hintText={LOOKUP.report.common.endDate.label}
                        fullWidth={true}
                    />
                </div> {/* .col */}
                <div className="col-xs-6 col-sm-12 col-md-6 col-lg-5 col-xl-5 m-0">
                    <BranchMultiSelectAutoCompleteInput
                        defaultValues={defaultBranch}
                        name={componentName + LOOKUP.report.common.branchName}
                        fullWidth={true}
                        autoWidth={true}
                        label="Branches"
                        floatingLabelText="Branches"
                        hintText="Branches"
                        style={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "16px", letterSpacing: "-0.25px" }}
                        options={branchOptions}
                        fieldName={'Branches'}
                        className={"multi-selector"}
                    />
                </div>
                {/* .col */}
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 p-0">
                    <SelectInput
                        name={componentName + LOOKUP.report.common.employeeName.name}
                        fullWidth={true}
                        label={LOOKUP.report.common.employeeName.label + "*"}
                        floatingLabelText={LOOKUP.report.common.employeeName.label + "*"}
                        hintText={LOOKUP.report.common.employeeName.label + "*"}
                        defaultValue="0"
                        options={props.employeeOptions}
                    />
                </div> {/* .col EMPLOYEES */}
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1 mb_xs p-0">
                    <Button
                        type="IconInButton"
                        className="pull-right mt-2 ml-1 btnNewBrandPOS"
                        fullWidth={true}
                        name={componentName + LOOKUP.report.common.viewReport.name}
                        label={LOOKUP.report.common.viewReport.label}
                        icon={<VisibilityIcon />}
                        onTouchTap={props.showBody}
                    />
                    <Button
                        type="DownloadButton"
                        className="pull-right mt-2 btnNewBrandPOS"
                        name={componentName + LOOKUP.report.common.downloadReport.name}
                        label={LOOKUP.report.common.downloadReport.label}
                        onTouchTap={props.download}
                    />
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
                    <p className='purpleText'><b>Note: </b><i>To receive the correct result in the following report, please close all registers with </i><strong className="danger">"Closing in Progress"</strong> <i>status.</i></p>
                </div>
            </div>
        </CardSimple>
    );
};

export default Header;
